import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { InventarioCapaService } from 'src/app/services/inventario-capa.service';
import { PlayAudiosService } from 'src/app/services/audios/playAudios.service';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs/operators';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ModalPedidosEncontradosComponent } from './modal-pedidos-encontrados/modal-pedidos-encontrados.component';
import { detectar_mobile } from 'src/app/@shared/helpers/vesta-helpers';
import { MatTableDataSource } from '@angular/material/table';
import { ConsultaBarcodeService } from 'src/app/services/consulta-barcode/consulta-barcode.service';
import { DEF_VOL_COLS, ObjetoGridVolumes } from 'src/app/@shared/models/selecao-volumes/objeto-grid-volumes.model';
import { ValidarManifestoTransferenciaResponse } from 'src/app/@shared/models/manifesto-transferencia.model';
import { Volume } from 'src/app/@shared/models/selecao-volumes/selecao-volumes.model';
import { debug } from 'console';

@Component({
  selector: 'app-inventario-contagem-itens',
  templateUrl: './inventario-contagem-itens.component.html',
  styleUrls: ['./inventario-contagem-itens.component.scss']
})
export class InventarioContagemItensComponent implements OnInit {

  public modalItem: any;
  public isLoading = false;
  public error = {} as any;
  public isMobile: boolean;
  public inventarioContagemId;
  public pedidoEtiquetaId;
  public inventarioContagem = {} as any;
  public status: Array<any>;
  public paging = { index: 0, size: 5, length: 0 };
  public permissions = { canCreate: false, canOpen: false };
  public shouldDisable = false;
  public totalNRT;
  public totalVolume;

  @ViewChild('pedidoIdOrDocumento', { static: true }) pedidoIdOrDocumento: ElementRef;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  public inventarioContagemForm: FormGroup = new FormGroup({
    inventarioId: new FormControl({ value: "", disabled: true }),
    numeroContagem: new FormControl({ value: "", disabled: true }),
    agente: new FormControl({ value: "", disabled: true }),
    dtCriacao: new FormControl({ value: "", disabled: true }),
    criadoPor: new FormControl({ value: "", disabled: true }),
    inventariante: new FormControl({ value: "", disabled: true }),
    pedidoIdOrDocumento: new FormControl(),
    totalNRT: new FormControl({ value: "", disabled: true }),
    totalVolume: new FormControl({ value: "", disabled: true }),
  });

  get codigoBarras() { return this.inventarioContagemForm.get('pedidoIdOrDocumento').value; }


  objetoGrid: ObjetoGridVolumes<ValidarManifestoTransferenciaResponse> = {
    grid: [],
    manifestoGerado: null,
    opcaoSelecionada: null,
    disabledButtonFinalizar: null,
    disabledButtonLiberar: null,
    showCols: DEF_VOL_COLS,
  };

  public displayedColumns: string[] = [
    'dataCriacao',
    'pedidoId',
    'barcode'
  ];

  public collection: MatTableDataSource<any> = new MatTableDataSource<any>();

  constructor(
    private inventarioCapaService: InventarioCapaService,
    private playAudioService: PlayAudiosService,
    public dialog: MatDialog,
    public router: Router,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public barcodeService: ConsultaBarcodeService
  ) { }

  updateLoadingSubscription: any;
  onPackageSelectedSubscription: any;

  ngOnInit() {
    this.isMobile = detectar_mobile();
    //  this.isMobile = true;

    if (this.isMobile === false){
      this.displayedColumns.push('etiqueta');
      this.displayedColumns.push('cliente');
    }

    this.updateLoadingSubscription     = this.barcodeService.updateLoading.subscribe((data: boolean) => this.isLoading = data);
    this.onPackageSelectedSubscription = this.barcodeService.onPackageSelected
    .subscribe((data: Volume) => {
      if (data) {
        this.inventarioContagemForm.get('pedidoIdOrDocumento').setValue(data.pedidoId);
        this.pedidoEtiquetaId = data.pedEtiqueta;
        this.registrarInventarioContagemItem();
        // this.validaLimite(data);
        this.isLoading = false;
      } else {
        this.playAudioService.playBeepSound();
        this.pedidoIdOrDocumento.nativeElement.value = "";
      }
    });
  }

  ngOnDestroy() {
    if (this.onPackageSelectedSubscription) {
       this.onPackageSelectedSubscription.unsubscribe()
     }
 }

  async ngAfterViewInit() {
    let encodedParams = this.route.snapshot.paramMap.get('params');
    let params = JSON.parse(encodedParams ? atob(decodeURIComponent(encodedParams)) : '{}');
    this.inventarioContagemId = params?.inventarioContagemId;
    this.cdr.detectChanges();
    this.search();
    this.initLastContagemItens();
  }

  public search() {
    this.loadInventarioContagens();
  }

  public enter(event) {
    if (event.keyCode === 13) {
      this.registrarInventarioContagemItem();
    }
  }

  public initLastContagemItens() {
    this.inventarioCapaService.getUltimosItensContadosAsync({
      inventarioContagemId: this.inventarioContagemId,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size
    })
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any[]>) => {
          this.collection.data = response.body;
          this.paging.length = response.body[0].totalCount;
          this.totalNRT = response.body[0].totalNRT;
          this.totalVolume = response.body[0].totalVolume;
          this.inventarioContagemForm.get('totalNRT').setValue(this.totalNRT);
          this.inventarioContagemForm.get('totalVolume').setValue(this.totalVolume);
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.initLastContagemItens();
  }

  public registrarInventarioContagemItem() {
    this.error.message = '';
    this.shouldDisable = true;
    document.body.style.cursor = "wait";
    document.getElementById('okButton').style.cursor = 'wait'

    this.inventarioCapaService.registrarInventarioContagemItem({
      inventarioContagemId: this.inventarioContagemId,
      pedidoDocumento: this.inventarioContagemForm.get('pedidoIdOrDocumento').value,
      pedidoEtiquetaId: this.pedidoEtiquetaId
    })
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any[]>) => {
          this.isLoading = false;
          this.shouldDisable = false;
          document.body.style.cursor = "default";
          document.getElementById('okButton').style.cursor = 'default'
          // this.loadInventarioContagens();
          this.openSnackBar('Item contabilizado com sucesso!', 'OK', 5000);
          this.inventarioContagemForm.get('pedidoIdOrDocumento').setValue('');
          this.initLastContagemItens();
          // this.clearForm();
        },
        (response) => {
          this.isLoading = false;
          this.shouldDisable = false;
          document.body.style.cursor = "default";
          document.getElementById('okButton').style.cursor = 'default'

          if (response.error.code === 101) {
            this.openModalPedidosEncontrados();
          }
          else if (response.status === 409) {
            this.playAudioService.playBeepSound();
            this.inventarioContagemForm.get('pedidoIdOrDocumento').setValue('');
            this.error.message = response.error.message;
          }
          else if (response.status === 404) {
            this.playAudioService.playBeepSound();
            this.inventarioContagemForm.get('pedidoIdOrDocumento').setValue('');
            this.error.message = 'Item não encontrado.';
          }
        });
  }

  public onChangeEvent() {
    this.error = {} as any;
  }

  buscaCodigoDeBarra() {
    if (!this.codigoBarras) {
      return this.openSnackBar('Informe um código de barra!', 'OK', 3000, 'warning-snackbar');
    }
    this.isLoading = true;
    this.barcodeService.consultaBarcodeInventario(this.codigoBarras, this.objetoGrid, this.inventarioContagemId);
  }


  public openModalPedidosEncontrados(): void {

    const modalReference = this.dialog.open(ModalPedidosEncontradosComponent, {
      width: !this.isMobile ? '900px' : '96vw',
      maxWidth: '96vw',
      data: {
        isMobile: this.isMobile,
        pedidoDocumento: this.inventarioContagemForm.get('pedidoIdOrDocumento').value
      }
    });

    modalReference.afterClosed().pipe(take(1)).subscribe((response) => {
      if (response && response.pedidoIds) {
        this.inventarioContagemForm.get('pedidoIdOrDocumento').setValue(response.pedidoIds[0]);
        this.registrarInventarioContagemItem();
      }
    });
  }


  private clearForm() {
    this.inventarioContagemForm.reset();
    this.inventarioContagemForm.markAsPristine();
    this.inventarioContagemForm.updateValueAndValidity();
    this.pedidoIdOrDocumento.nativeElement.focus();
  }

  private loadInventarioContagens() {
    this.isLoading = true;
    this.inventarioCapaService.getAllInventarioContagens({
      inventarioContagemId: this.inventarioContagemId,
      isMobile: this.isMobile,
    })
      .pipe(take(1))
      .subscribe((response: HttpResponse<any>) => {

        if (!response.body || response.body.length !== 0) {
          this.inventarioContagem = response.body.filter(p => p.inventarioContagemStatusId === 1)[0];
          if (!this.inventarioContagemId || this.inventarioContagemId <= 0)
            this.inventarioContagemId = this.inventarioContagem.inventarioContagemId;
          this.loadFields();
          this.isLoading = false;
        } else {
          this.openSnackBar('Não existe nenhuma contagem aberta no momento!', 'OK', 5000, 'warning-snackbar');
          this.router.navigate(['/dashboard']);
          return;
        }
      }, (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  private loadFields() {
    this.inventarioContagemForm.get('inventarioId').setValue(this.inventarioContagem.inventarioId);
    this.inventarioContagemForm.get('numeroContagem').setValue(this.inventarioContagem.numeroContagem);
    this.inventarioContagemForm.get('agente').setValue(this.inventarioContagem.agente);
    this.inventarioContagemForm.get('dtCriacao').setValue(this.inventarioContagem.dtCriacao);
    this.inventarioContagemForm.get('criadoPor').setValue(this.inventarioContagem.criadoPor);
    this.inventarioContagemForm.get('inventariante').setValue(this.inventarioContagem.inventariante);
  }

  public voltar() {
    const params = encodeURIComponent(btoa(JSON.stringify({ inventarioId: this.inventarioContagem.inventarioId })));
    this.router.navigate(['/inventario/contagens', params]);
  }

  private openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
